import React from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';

const WeightOfWaters = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='lg:px-32 lg:py-10 mb-44 lg:mb-0 lg:pb-0 p-14 lg:pt-20'
    >
    <div className='lg:flex flex-2'>
        <div className='lg:h4 h5 flex-1'>
            Weight of Waters <br/>(Decolonizing the Mundi) <br/>
                      <p><hr className="border-t border-2 border-gray-800 my-6 w-1/3" /></p>
                      <div
                
                  className=" border-2 border-black hover:scale-110 hover:bg-zinc-900 hover:text-white w-fit p-4 hover:cursor-pointer"
                >
                  View album
                </div>

        </div>
        <div className='flex-1'>
            <p className='text-sm lg:pb-20'>Parimah Avani and Arta Shadman <br/> Curated by Bianca Bellucci <br/> Festival Decolonizzare i Mondi, Genova – November 17, 2024 <br/>Presented by Centro Culturale Primo Levi<br/> Hosted at Biblioteca Universitaria di Genova <br/><br/>
            "Weight of Waters" was presented within the Festival Decolonizzare i Mondi (Decolonizing the Worlds) in Genoa, curated by Bianca Bellucci, and hosted by the Biblioteca Universitaria di Genova in collaboration with the Centro Culturale Primo Levi. Genoa—birthplace of Cristoforo Colombo—stands as a potent and symbolic site for this decolonial reflection. The project marked the beginning of a meaningful curatorial dialogue and ongoing collaboration between Bellucci and Parimah Avani, dedicated to future interventions addressing colonial legacy and cultural repair.
Conceived by Parimah Avani with a sound installation by Arta Shadman, the project explores decolonization through elemental and symbolic language, confronting histories of control and extraction. The installation incorporates soil, textile, salt, and empty bottles, composing a visceral narrative of rebellion and reclamation. The act of drawing rebels in soil directly onto the floor transforms the space into a living archive of resistance.
Soil—both tangible and symbolic—carries the burden of displacement and the enduring struggle for autonomy. Salt, referencing colonial monopolies and anti-colonial resistance, becomes a charged relic within the installation: once a tool of domination, here it reclaims its place as a symbol of uprising. Empty alcohol bottles evoke extractive practices that drain not only material resources but also culture and spirit—quiet markers of dispossession.
The interplay of fabric, earth, and found objects invites viewers to reflect on the connections between labor, resource exploitation, and collective memory. With Weight of Waters, the gallery is transformed into a space of decolonial inquiry—urging us to unearth suppressed histories, dismantle inherited narratives, and reimagine more just futures.

<br/>
<br/>

</p>
        </div>
    </div>
    </motion.section>
  )
}

export default WeightOfWaters